import { EditorView } from '@tiptap/pm/view';

/** Flat cursor rectangle in viewport coordinates, as returned by ProseMirror. */
type PosCoords = ReturnType<EditorView['coordsAtPos']>;

// ProseMirror returns an all-zero rect when it cannot measure a position, as happens
// at the end of a block where there is no following character to anchor to. A real
// caret always has positive height, so an all-zero rect never denotes a valid position.
function isEmptyRect(coords: PosCoords): boolean {
  return coords.left === 0 && coords.right === 0 && coords.top === 0 && coords.bottom === 0;
}

/**
 * Resolves viewport coordinates for a document position, measuring the following
 * character first and falling back to the preceding one when the forward measurement
 * yields no rect, as happens at the end of a block.
 */
export function resolveCoordsAtPos(view: EditorView, pos: number): PosCoords {
  const forward = view.coordsAtPos(pos, 1);
  if (!isEmptyRect(forward)) return forward;

  return view.coordsAtPos(pos, -1);
}
